var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-panel',{staticClass:"panel-wrapper",attrs:{"title":_vm.title,"hide-button":true}},[_vm._t("default",function(){return [_c('div',{staticClass:"description"},[_vm._v(" "+_vm._s(_vm.description)+" ")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }